import { Pill, type PillProps, type PillVariant } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import { getOneOfType, type IxcFundingV1BatchTransferType, type IxcFundingV1BatchTransferTypeOneOfValue } from '@interxfi/types';

const labelsWithoutPrefix: Record<IxcFundingV1BatchTransferTypeOneOfValue, string> = {
  achPush: 'Push',
  achPull: 'Pull',
};

const variantByType: Record<IxcFundingV1BatchTransferTypeOneOfValue, PillVariant> = {
  achPush: 'danger',
  achPull: 'green',
};

interface FundingBatchTransferDirectionPillProps extends Omit<PillProps, 'children'> {
  type: IxcFundingV1BatchTransferType | IxcFundingV1BatchTransferTypeOneOfValue | undefined;
  withoutTypePrefix?: boolean;
}

export function FundingBatchTransferDirectionPill({ as, isPending, type: t, withoutTypePrefix, ...props }: FundingBatchTransferDirectionPillProps) {
  const oneOfValue = typeof t === 'string' ? t : getOneOfType(t);

  return (
    <Pill isPending={!oneOfValue || isPending} {...props} variant={(oneOfValue ? variantByType[oneOfValue] : undefined) ?? 'neutral'}>
      {withoutTypePrefix && oneOfValue ? (
        labelsWithoutPrefix[oneOfValue]
      ) : (
        <TranslatedText
          defaultValue={oneOfValue}
          i18nKey={{ namespace: 'ixcFundingV1', oneOfName: 'IxcFundingV1BatchTransferType', value: oneOfValue }}
        />
      )}
    </Pill>
  );
}
